// @flow

import moment from 'moment';

import ApiObject from '../ApiObject';

import AbstractOrderModeSetting from './AbstractOrderModeSetting';

import DeliveryTimeSettings from './DeliveryTimeSettings';

export default class DeliveryOrderSettings extends AbstractOrderModeSetting {

	/**
	* maximum range the restaurant can deliver to.
	* @type Number
	*/
	maxRangeInMeters: Meters = 0;

	/**
	* The price of the delivery. It bacame 0 when the order total price is equal or greater than the `minimumPriceForFreeDelivery`
	*/
	deliveryPrice: Price = 0;

	/**
	* If the order total price is equal or greater than the `minimumPriceForFreeDelivery`, the
	* deliveryPrice became 0.
	*/
	minimumPriceForFreeDelivery: Price = 0;

	deliveryTimeSettings: DeliveryTimeSettings = new DeliveryTimeSettings();

	postJsonAsssignation(data) {
		this.deliveryTimeSettings = new DeliveryTimeSettings().fromJson(data.deliveryTimeSettings);
	}

	isTooFarToDelivery(distance: Meters): boolean {
		return distance > this.maxRangeInMeters;
	}

}
